import React from 'react'

import { SVGWrapper } from '@vividseats/vivid-ui-kit'
import type { CustomIcon } from '@vividseats/vivid-ui-kit/dist/components/custom-icons/types'

const FrontOfSectionIcon: React.FC<CustomIcon> = ({ className, fontSize, width, height, ...props }) => (
    <SVGWrapper className={className} fontSize={fontSize} width={width} height={height}>
        <svg {...props} width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.42871" y="4.78564" width="7.14286" height="1" rx="0.5" fill="#04092C" />
            <rect x="3.71387" y="7.5" width="8.57143" height="1" rx="0.5" fill="#A0A2B3" />
            <rect x="3" y="10.2144" width="10" height="1" rx="0.5" fill="#A0A2B3" />
        </svg>
    </SVGWrapper>
)

export default FrontOfSectionIcon
